module.exports = __webpack_public_path__ + "media/images/proof_links/quora-2bac389c7d8f0c6caf929cf17a4b1724.svg";